/* eslint-disable no-undef */
import React, { useState, useEffect, createContext } from 'react';
import packageJson from '../../../package.json';

global.appVersion = packageJson.version;

// version from response - first param, local version second param
const semverGreaterThan = (versionA, versionB) => {
  const versionsA = versionA.split(/\./g);

  const versionsB = versionB.split(/\./g);
  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());

    const b = Number(versionsB.shift());
    // eslint-disable-next-line no-continue
    if (a === b) continue;
    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b);
  }
  return false;
};

const refreshCacheAndReload = async () => {
  console.log('Clearing cache and hard reloading...');
  if (caches) {
    // Service worker cache should be cleared with caches.delete()
    const names = await caches.keys();

    names.forEach(name => caches.delete(name));
  }

  // delete browser cache and hard reload
  window.location.reload(true);
};

export const CacheContext = createContext();

export default ({ children }) => {
  const [loading, setLoading] = useState(true);

  const fetchVersion = async () => {
    // eslint-disable-next-line no-undef
    const response = await fetch('/meta.json');
    const meta = await response.json();

    const latestVersion = meta.version;
    const currentVersion = global.appVersion;

    const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);

    // If we need to refresh
    if (shouldForceRefresh) {
      console.log(
        `We have a new version - ${latestVersion}. Should force refresh`
      );
      refreshCacheAndReload();
    }

    // Set the loading state
    setLoading(false);
  };

  // On Mount fetch the current version and refresh if needed
  useEffect(() => {
    fetchVersion();
  }, []);

  return (
    <CacheContext.Provider
      value={{
        loading,
      }}
    >
      {children}
    </CacheContext.Provider>
  );
};
